const getNewsletterTitle = cinemaData => cinemaData.campaignName


export default getNewsletterTitle